import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { filter, take, takeWhile } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as fromDataServices from '../../data-services';
import { EditGrid, ResponseStatus } from '../../shared';
import { SelectItem, Table } from '../../shared/efaact-primeng.module';
import { UnsavedChangesService } from '../../shared/modal-dialog';
import { LoggingService } from '../../shared/services/logging/logging.service';
@Component({
    selector: 'ef-project-budget-contract',
    templateUrl: './project-budget-contract.component.html',
    styleUrls: ['./project-budget-contract.component.scss'],
    standalone: false
})
export class ProjectBudgetContractComponent
    extends EditGrid<fromDataServices.Contract.Summary.ContractSummary>
    implements OnInit, AfterViewInit, OnDestroy, OnChanges {
    dropdownItemHeight = environment.dropdownItemHeight;
    private ItemsSubject = new ReplaySubject<
        fromDataServices.Contract.Summary.ContractSummary[]
    >(1);
    moment: any;
    @Input() BudgetCycles: SelectItem[];
    @Input() BudgetLevels: SelectItem[];
    @Input() contractFilterSelectItems: SelectItem[];
    @Input() public set download(value) {
        this.log.verbose({
            type: 'ProjectBudgetContractComponent:download:set',
            value
        });
        if (!!value) {
            this.dataTable.exportCSV.bind(this.dataTable)();
        }
    }
    @Output() BudgetCycleChange = new EventEmitter<string>();
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @Input() disabled = false;
    active = true;
    cols = [
        { field: 'Contractdesc', header: 'Contract' },
        { field: 'Budgetcycle', header: 'Budget Cycle' },
        { field: 'Budgetlevel', header: 'Budget Level' },
        { field: 'BudgetEndDate', header: 'Budget End Date' },
        { field: 'Contractvalue', header: 'Contract Value' },
        { field: 'Contractfunding', header: 'Contract Funding' },
        { field: 'Totalhoursbudget', header: 'Total Hours Budget' },
        { field: 'Totalhoursspent', header: 'Total Hours Spent' },
        { field: 'Totalhoursvariance', header: 'Total Hours Variance' },
        { field: 'Totalamountbudget', header: 'Total Amount Budget' },
        { field: 'Totalamountspent', header: 'Total Amount Spent' },
        { field: 'Totalamountvariance', header: 'Total Amount Variance' }
    ];
    numCols = 15;
    IsColumnFrozen = false;
    @Input() tableScrollHeight;
    constructor(
        private log: LoggingService,
        private confirmservice: UnsavedChangesService
    ) {
        super();
        this.moment = moment;
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes.items && changes.items.currentValue) {
            this.ItemsSubject.next(changes.items.currentValue);
        }
    }

    ngOnInit(): void {
        this.setupSubscriptions();
    }
    ngAfterViewInit(): void {
        this.IsColumnFrozen = true;
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    setupSubscriptions() {
        this.ItemsSubject.pipe(
            takeWhile(() => this.active),
            filter(x => !!x && !(x.length < 1)),
            take(1)
        ).subscribe(items => {
            this.selected = items[0];
            this.onRowSelect({ data: items[0] });
        });
    }
    onRowEditInit(item: fromDataServices.Contract.Summary.ContractSummary) {
        this.log.verbose({
            type: 'ProjectBudgetContractComponent:onRowEditInit',
            item
        });
        super.onRowSelect({ data: item });
        super.onRowEditInit(item);
    }
    onRowEditSave(item: fromDataServices.Contract.Summary.ContractSummary) {
        this.log.verbose({
            type: 'ProjectBudgetContractComponent:onRowEditSave',
            item,
            cloned: this.cloned,
            editing: this.editing,
            selected: this.selected
        });
        const needsConfirm =
            item.Budgetcycleid !== this.cloned[item.id].Budgetcycleid;
        if (needsConfirm) {
            this.confirmservice
                .confirm({
                    headerText: 'Are you sure?',
                    dialogText:
                        'Changing budget cycle or budget level will remove ALL budgets for the selected contract.',
                    okClass: 'p-button-danger p-button-text'
                })
                .pipe(take(1))
                .subscribe(confirmed => {
                    if (confirmed) {
                        item.Status.StatusCode = ResponseStatus.Loading;
                        item.Status.Message = 'Saving';

                        this.SaveItem.next(item);
                        delete this.cloned[item.id];
                        delete this.editing;
                        this.selected = null;
                    } else {
                        this.onRowEditCancel(item);
                    }
                });
        } else {
            item.Status.StatusCode = ResponseStatus.Loading;
            item.Status.Message = 'Saving';

            this.SaveItem.next(item);
            delete this.cloned[item.id];
            delete this.editing;
            this.selected = null;
        }
    }
    onRowEditDelete(
        item: fromDataServices.Contract.Summary.ContractSummary,
        index: number
    ) {
        this.confirmservice
            .confirmPromise({
                dialogText: `Are you sure you want to delete this contract?`
            })
            .then(() => {
                // if (item.id === 'add') {
                //     this.items.splice(index, 1, { ...this.addTemplate } as any);
                // } else {
                this.items.splice(index, 1, this.cloned[item.id]);
                // }

                this.DeleteItem.next([item]);

                delete this.cloned[item.id];
                delete this.editing;
                return;
            })
            .catch(e => {});
    }
    onLockClick(item: fromDataServices.Contract.Summary.ContractSummary) {
        this.log.verbose({
            type: 'ProjectBudgetContractComponent:onLockClick',
            item
        });
        this.onRowEditInit(item);
        item.BudgetLock = !item.BudgetLock;
        this.onRowEditSave(item);
    }
}
